var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _path9, _path10, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.288 265.34l19.022 46.948-19.022 55.862-78.647-24.26c5.027-13.77 12.062-26.67 20.906-38.15 7.535-9.76 11.892-19.97 13.021-30.4z",
    fill: "#e6f7ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.925 343.89l-78.637 24.26V265.34l44.72 10c1.129 10.43 5.486 20.64 13.021 30.4 8.844 11.48 15.879 24.38 20.896 38.15z",
    fill: "#b3e5ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.288 343.89l39.373 84.055L337.288 512h-72.791c-8.279 0-14.99-6.716-14.99-15V395.72c0-17.87 3.148-35.46 9.134-51.83z",
    fill: "#c9f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M425.059 395.72l-.41 116.28h-87.361V343.89h78.637c5.986 16.37 9.134 33.96 9.134 51.83z",
    fill: "#b366ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.773 265.34l19.022 46.948-19.022 55.862-78.647-24.26c5.027-13.77 12.062-26.67 20.906-38.15 7.535-9.76 11.892-19.97 13.021-30.4z",
    fill: "#e6f7ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 343.89l-78.637 24.26V265.34l44.72 10c1.129 10.43 5.486 20.64 13.021 30.4 8.844 11.48 15.879 24.38 20.896 38.15z",
    fill: "#b3e5ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.773 343.89l39.373 84.055L99.773 512H26.982c-8.274 0-14.99-6.72-14.99-15V395.72c0-17.87 3.148-35.46 9.134-51.83z",
    fill: "#c9f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.544 395.72V497c0 8.28-6.715 15-14.99 15H99.773V343.89h78.637c5.986 16.37 9.134 33.96 9.134 51.83z",
    fill: "#b366ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.528 10l19.022 46.948-19.022 55.862-78.647-24.26c5.027-13.77 12.062-26.67 20.906-38.15 7.535-9.76 11.892-19.97 13.021-30.4z",
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.165 88.55l-78.637 24.26V10l44.72 10c1.129 10.43 5.486 20.64 13.021 30.4 8.844 11.48 15.879 24.38 20.896 38.15z",
    fill: "#b3e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.528 88.55l39.373 84.055-39.373 84.055h-72.791c-8.274 0-14.99-6.72-14.99-15V140.38c0-17.87 3.148-35.46 9.134-51.83z",
    fill: "#c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.299 140.38v101.28c0 8.28-6.716 15-14.99 15h-72.781V88.55h78.637c5.986 16.37 9.134 33.96 9.134 51.83z",
    fill: "#b366ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.649 337.17V512c-48.168 0-87.361-39.21-87.361-87.41s39.193-87.42 87.361-87.42z",
    fill: "#ffea80"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512 424.59c0 48.2-39.184 87.41-87.351 87.41V337.17c48.167 0 87.351 39.22 87.351 87.42z",
    fill: "#ffc34d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.523 245.34L233.524 256l-15.001 19.34H14.99c-8.274 0-14.99-6.72-14.99-15s6.716-15 14.99-15z",
    fill: "#665c99"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.523 0l19.026 14.254L218.523 30h-53.434c-8.274 0-14.99-6.72-14.99-15s6.716-15 14.99-15z",
    fill: "#665c99"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#554080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.947 15c0 8.28-6.715 15-14.99 15h-53.434V0h53.434c8.274 0 14.99 6.72 14.99 15zM437.046 260.34c0 8.28-6.716 15-14.99 15H218.523v-30h203.533c8.274 0 14.99 6.72 14.99 15z"
  }))));
}

export default __webpack_public_path__ + "84698bb9906eaa7249e86eac73870115.svg";
export { SvgFamily as ReactComponent };